import { Maybe } from 'graphql/jsutils/Maybe';
import {
  ShiftChangeRequestColleagueApprovalStatus,
  ShiftChangeRequestDetailedStatus,
} from '../../../__generated__/graphql';

export const getDetailedStatusBadgeColor = (
  status: ShiftChangeRequestDetailedStatus,
): string => {
  switch (status) {
    case ShiftChangeRequestDetailedStatus.PendingColleagueApproval:
    case ShiftChangeRequestDetailedStatus.PendingManagersApproval:
      return 'bg-warning';
    case ShiftChangeRequestDetailedStatus.Approved:
      return 'bg-success';
    case ShiftChangeRequestDetailedStatus.RejectedByColleague:
    case ShiftChangeRequestDetailedStatus.RejectedByManagers:
      return 'bg-danger';
    case ShiftChangeRequestDetailedStatus.CancelledByRequester:
      return 'bg-secondary';
    default:
      return 'bg-secondary';
  }
};

export const getColleagueBadgeColor = (
  status: Maybe<ShiftChangeRequestColleagueApprovalStatus>,
): string => {
  if (!status) {
    return 'bg-secondary';
  }
  switch (status) {
    case ShiftChangeRequestColleagueApprovalStatus.Pending:
      return 'bg-warning';
    case ShiftChangeRequestColleagueApprovalStatus.Accepted:
      return 'bg-success';
    case ShiftChangeRequestColleagueApprovalStatus.Declined:
      return 'bg-danger';
    default:
      return 'bg-secondary';
  }
};
